import { createAction, props } from "@ngrx/store";
import { Metadata, Property } from "../models";

export const loadMetadata = createAction('[Metadata Data] Load Metadata');
export const loadMetadataFailure = createAction('[Metadata Data] Load Metadata Failure', props<{ error:any }>());
export const loadMetadataSuccess = createAction('[Metadata Data] Load Metadata Success', props<{ metadata:Property[] }>());